import EntityListCell from '@/components/Reports/Cell/EventCell.vue'

const config = {
  cellRenderer: EntityListCell
}
export default {
  type: 'Event',
  config
}
